import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=166ad82f&scoped=true"
import script from "./nutrition.vue?vue&type=script&lang=js"
export * from "./nutrition.vue?vue&type=script&lang=js"
import style0 from "./nutrition.vue?vue&type=style&index=0&id=166ad82f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ad82f",
  null
  
)

export default component.exports